import { Component, Input, HostBinding } from '@angular/core';

/**
 * MDB Toolbar Component
 *
 * A flexible toolbar/navbar component with MDB5 styling.
 *
 * Usage:
 * ```html
 * <mdb-toolbar color="primary">
 *   <div class="toolbar-content">
 *     <h1>My App</h1>
 *   </div>
 * </mdb-toolbar>
 * ```
 */
@Component({
  selector: 'mdb-toolbar',
  template: '<ng-content></ng-content>',
  standalone: false,
})
export class MdbToolbarComponent {
  @Input() color: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | '' = '';
  @Input() position: 'fixed-top' | 'fixed-bottom' | 'sticky-top' | '' = '';
  @Input() expand: 'sm' | 'md' | 'lg' | 'xl' | '' = '';

  @HostBinding('class')
  get toolbarClasses(): string {
    const classes: string[] = ['navbar'];

    if (this.color) {
      classes.push(`navbar-${this.color}`);
      // Add background color for better visibility
      if (this.color !== 'light') {
        classes.push(`bg-${this.color}`);
      }
    }

    if (this.position) {
      classes.push(this.position);
    }

    if (this.expand) {
      classes.push(`navbar-expand-${this.expand}`);
    } else {
      classes.push('navbar-expand-lg'); // Default expand
    }

    return classes.join(' ');
  }
}
